
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <p class="modal-title">
        <i class="fas fa-cog mr-2"></i>
        <span class="font-weight-bold">Multi-Factor Authentication</span>
      </p>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="container-fluid py-3">
        <div class="row justify-content-center mb-3">
          <div class="col-12 text-center">
            <p class="mb-2">
              Enter the 6-digit code from your authenticator app to continue.
            </p>
          </div>
        </div>
        <div class="row justify-content-center mb-2">
          <div class="col-12 col-md-8 col-lg-6">
            <div class="input-group mb-2">
              <input
                v-model="code"
                class="form-control text-center"
                maxlength="6"
                placeholder="000000"
                autofocus
                @keyup.enter="onSubmit"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-dark btn-sm"
                  @click="onSubmit"
                  :disabled="pending"
                >
                  <span v-if="!pending">Verify</span>
                  <span v-else><i class="fas fa-spinner fa-spin"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
